import { useState, useEffect } from "react";
import { useQuery, gql } from "@apollo/client";
import {
  LIST_DISCIPLINES,
  LIST_DISCIPLINES_QUERY_OPTIONS,
} from "apollo/queries/disciplines";
import { formatListArray } from "utils";

const useWesternDisciplines = () => {
  const [westernOptions, setWesternOptions] = useState([]);
  const { data: listDisciplinesData } = useQuery(
    gql(LIST_DISCIPLINES),
    LIST_DISCIPLINES_QUERY_OPTIONS
  );

  useEffect(() => {
    if (listDisciplinesData?.listDisciplines) {
      const formattedOptions = formatListArray(
        listDisciplinesData.listDisciplines
      );
      const filteredWesternOptions = formattedOptions.filter(
        (option) => String(option?.label ?? "").toUpperCase() === "WESTERN"
      );
      setWesternOptions(filteredWesternOptions);
    }
  }, [listDisciplinesData]);

  const mapDisciplineValue = (value) => {
    for (const discipline of westernOptions) {
      const foundOption = discipline.options.find(
        (option) => option.value === value
      );
      if (foundOption) {
        return foundOption;
      }
    }
    return null;
  };

  return { westernOptions, mapDisciplineValue };
};

export default useWesternDisciplines;
